export const environment = {
  production: true,
  apiURL: "https://qupil-release-app-itwdaqrulq-oa.a.run.app/api",
  appId: "880e00779d454230b85023256c6b9bad",
  createLectureFeatureFlag: true,
  firebase: {
    apiKey: "AIzaSyDz7JfbialMrCcMnVExt8in91Ka5TS8NoQ",
    authDomain: "qupil-345111.firebaseapp.com",
    databaseURL:
      "https://qupil-345111-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "qupil-345111",
    storageBucket: "qupil-345111.appspot.com",
    messagingSenderId: "60148088351",
    appId: "1:60148088351:web:469a3f4f75cf598d665f2a",
    measurementId: "G-6YX762CE86",
  },
  vapidKey: "BFjfNv-eY5yo64Igx3naBqN1qDSp8LL-R_lHnzoaskIKbB6hoh6UwuXaL7P6PZdrfisOnFASzspBsMw0vmfbdKw",
  intercomAppId: "shbk4qqg",
  intercomSecretKey: "DzC51VWC0d8kH2edzRv0nQm2WGpExkwH8a8fT95o",
  // QSL-9530: Stripe test bed (sandbox). Enabled on release for sandbox verification.
  // Backend also hard-guards the endpoint with NODE_ENV !== 'production'.
  stripeTestBedEnabled: true,
  stripePublishableKey:
    "pk_test_51KQTX5DzOBLQKUiq5ZXUsl4f6Ugk9MsBBWGRs5iD2k3XZ0HqnJairbTECkfz12U6wdfzRPHsivVOMx5l4hg8Cv7u00pg9objmE",
};
